import { Button, Modal, Tables } from '@ixyberfree/ixybercomponents';
import { IColum } from 'components/MainPage/dcs/centumvp/components/Table/Table';
import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import React, { useState } from 'react';

interface TableColumnsModalProps {
    onClose: () => void;
    onSave: (selectedColumns: string[]) => void;
    tableHeader: any[];
    selectData: any;
}

const EditColumns: React.FC<TableColumnsModalProps> = ({ onClose, onSave, tableHeader, selectData }) => {
    const [selectedColumns, setSelectedColumns] = React.useState<string[]>([]);
    //Фильтр
    const FilterKeys = [
        'name',
        'description',
        'shape',
        'ClassName',
        'path',
        'Key',
        'Value',
        'sourceIn.address',
        'sourceOut.address'
    ];

    const [dataEditTable, setDataEditTable] = useState<any[]>([]);

    const headerEditTable: IColum[] = [
        {
            type: 'select',
            width: '',
            label: 'selected',
            idCol: 'select',
            action: true
        },
        {
            type: 'text',
            width: '250px',
            label: 'Название столбца',
            idCol: 'label',
            action: true
        }
    ];

    const handleSelect = (item: any, check: boolean) => {
        const newCheckedProperties = check
            ? [...selectedColumns, item.id]
            : selectedColumns.filter((i) => i !== item.id);
        setSelectedColumns(newCheckedProperties);
    };

    const handleSelectAllProperties = (check: boolean, items: string[]) => {
        const newCheckedProperties = check ? items : [];
        setSelectedColumns(newCheckedProperties);
    };

    React.useEffect(() => {
        hmiclientbase.SettingsGetTypesWithProperties(selectData.id).then((obj: any) => {
            const uniqueKeys = new Set<string>();
            const checkedColumns: string[] = [];

            for (let key in obj) {
                const block = obj[key];
                Object.entries(block).forEach((key) => {
                    if (
                        ((key[1] as string).includes('String') &&
                            !FilterKeys.includes(key[0]) &&
                            !(key[1] as string).includes('Dictionary') &&
                            !(key[1] as string).includes('HashSet')) ||
                        (key[1] as string).includes('Int') ||
                        key[0].includes('IdTemplate') ||
                        key[0].includes('CV')
                    )
                        uniqueKeys.add(key[0]);
                });
            }

            let arr: any[] = Array.from(uniqueKeys).map((name) => ({ label: name }));

            tableHeader.forEach((column) => {
                const foundColumn = arr.findIndex((item) => item.label === column.idCol);

                if (foundColumn != -1) {
                    checkedColumns.push(foundColumn.toString());
                }
            });

            setSelectedColumns(checkedColumns);
            setDataEditTable(arr);
        });
    }, []);

    const handleSaveColumns = (selectedColumns: string[]) => {
        const Header: any[] = [
            { type: 'select', label: 'selected', width: '', idCol: 'select' },
            { type: 'text', label: 'Name', width: '200px', idCol: 'name' },
            { type: 'text', label: 'Description', width: '150px', idCol: 'description' },
            { type: 'text', label: 'ClassName', width: '200px', idCol: 'ClassName' },
            { type: 'text', label: 'Path', width: '200px', idCol: 'path' },
            { type: 'text', label: 'Shape', width: '150px', idCol: 'shape' },
            { type: 'text', label: 'SourceOut.address', width: '250px', idCol: 'sourceOut.address' },
            { type: 'text', label: 'SourceIn.address', width: '250px', idCol: 'sourceIn.address' }
        ];
        const filterData = ['sourceOut.address', 'sourceIn.address', 'quality'];

        selectedColumns.forEach((column) => {
            const foundColumn = dataEditTable.find((item, index) => index.toString() === column);
            if (foundColumn) {
                const label: string = foundColumn.label;
                const action: boolean = filterData.includes(label) ? true : false;

                const Column = {
                    action: action,
                    type: 'text',
                    label: label.charAt(0).toUpperCase() + label.slice(1),
                    width: '250px',
                    idCol: label
                };
                Header.push(Column);
            }
        });

        const headerString = JSON.stringify(Header);
        localStorage.setItem('tableHeader', headerString);

        onSave(Header);
        onClose();
    };

    return (
        <Modal className="modal-window" headerLabel="Добавить/Убрать столбец" width="20vw" onCloseClick={onClose}>
            <Tables
                header={headerEditTable}
                data={dataEditTable}
                allChecked={true}
                onAllCheck={handleSelectAllProperties}
                onCheck={handleSelect}
                checked={selectedColumns}
                width="100%"
                height="500px"
            />
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Button
                    text="Сохранить"
                    size="small"
                    styleType="filled"
                    onClick={() => handleSaveColumns(selectedColumns)}
                />
            </div>
        </Modal>
    );
};

export default EditColumns;
